import { Button, Modal, ModalFooterProps, ModalProps, ModalTitleProps } from 'react-bootstrap';

import { ICustomButtonProps } from '@customTypes/common';

interface IProps {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children: React.ReactNode;
  modalProps?: ModalProps;
  cancelBtnProps?: ICustomButtonProps;
  confirmBtnProps?: ICustomButtonProps;
  titleProps?: ModalTitleProps;
  footerProps?: ModalFooterProps;
  footerActions?: React.ReactNode;
  hideCloseButtonOnHeader?: boolean;
}

export default function CommonDialog({
  onClose,
  onConfirm,
  title,
  children,
  modalProps = {},
  cancelBtnProps = {},
  confirmBtnProps = {},
  titleProps = {},
  footerProps = {},
  footerActions,
  hideCloseButtonOnHeader = false,
}: IProps) {
  return (
    <Modal show onHide={onClose} id='common-dialog' aria-labelledby='common-modal-title' {...modalProps}>
      <Modal.Header closeButton={!hideCloseButtonOnHeader}>
        <Modal.Title as='h4' id='common-modal-title' className='fs-5 fw-medium lh-sm' {...titleProps}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className='gap-2' {...footerProps}>
        <Button
          variant='secondary'
          onClick={onClose}
          {...cancelBtnProps}
          className={`my-0 ${cancelBtnProps.className || ''}`}
        >
          {cancelBtnProps?.children ? cancelBtnProps.children : 'Cancel'}
        </Button>
        {footerActions}
        <Button
          variant='primary'
          onClick={onConfirm}
          {...confirmBtnProps}
          className={`my-0 ${confirmBtnProps.className || ''}`}
        >
          {confirmBtnProps?.children ? confirmBtnProps.children : 'Yes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
